import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink, IMultipleEntitiesResponse } from "@/types"
import LabelCategory, { IGetLabelCategoryDto } from "./LabelCategory"

export interface ICreateLabelCategoryDto {
    name: string
}

export interface ICreateLabelCategory {
    dto: ICreateLabelCategoryDto
    createLink: IApiLink
}

export interface IGetLabelCategoriesDto extends IMultipleEntitiesResponse<IGetLabelCategoryDto> {}

export default class LabelCategories {
    items: LabelCategory[]
    linkCreateLabelCategory?: IApiLink

    constructor(dto: IGetLabelCategoriesDto) {
        this.items = dto.entities.map(entityDto => new LabelCategory(entityDto))
        this.linkCreateLabelCategory = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.labelCategory && lnk.rel === ApiLinkRel.new)
    }
}
